import React, { useEffect, useState } from "react";
import Main from "../components/admin/Main";
import PageContainer from "../components/admin/PageContainer";
import Modal from "../components/admin/Modal";
import CollapseCard from "../components/admin/CollapseCard";
import ProductForm from "../components/admin/ProductForm";
import ProductsList from "../components/admin/ProductsList";
import {
  createProduct,
  deleteProduct,
  fetchAllProduct,
  updateProduct,
  verifyProductCode,
} from "../service/ProductService";
import { useToast } from "../components/toast/ToastProvider";
import { deleteProductImage } from "../service/ProductImageService";

const ProductPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [images, setImages] = useState([]);
  const [productForm, setProductForm] = useState({
    code: "",
    name: "",
    description: "",
    weight: "",
    makingCharge: "",
    wastageCharge: "",
    purity:"",
    status: "",
    stockAvailability: "",
    gst:"",
    discount:"",
    purchaseRate: "",
    purchaseGoldRate: "",
    purchaseDate: "",
    vendorId: "",
    categoryId: "",
    productType: "",
  });
  const [makingAmount, setMakingAmount] = useState("");
  const [wastageAmount, setWastageAmount] = useState("");
  const [isTypingMaking, setIsTypingMaking] = useState(false);
  const [isTypingWastage, setIsTypingWastage] = useState(false);
  const [isCodeDuplicate, setIsCodeDuplicate] = useState(false);
  const toast = useToast();
  const fetchData = async () => {
    const res = await fetchAllProduct();
    setProductData(res);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = async (e) => {
    const {name, value} = e.target;

    setProductForm((prev) => ({ ...prev, [name]: value }));
    if(name === 'code'){
      setIsCodeDuplicate(false);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
  };
 const handleCodeBlur = async () => {
  if (!productForm.code) return;

  if (editIndex && editIndex.code === productForm.code) {
    setIsCodeDuplicate(false);
    return;
  }

  try {
    const res = await verifyProductCode(productForm.code);
      console.log("res",res);
    if (res?.isExists === 1 || res?.isExists === "1") {
      setIsCodeDuplicate(true);
    } else {
      setIsCodeDuplicate(false);
    }

  } catch (err) {
    console.error("Code verification failed", err);
  }
};
  useEffect(() => {
  const rate = parseFloat(productForm.purchaseRate);

  if (!rate || rate <= 0) {
    setMakingAmount("");
    setWastageAmount("");
    return;
  }

  const makingPercent = parseFloat(productForm.makingCharge) || 0;
  const wastagePercent = parseFloat(productForm.wastageCharge) || 0;

  if (!isTypingMaking && productForm.makingCharge !== "") {
    setMakingAmount(((rate * makingPercent) / 100).toFixed(2));
  }

  if (!isTypingWastage && productForm.wastageCharge !== "") {
    setWastageAmount(((rate * wastagePercent) / 100).toFixed(2));
  }
}, [
  productForm.makingCharge,
  productForm.wastageCharge,
  productForm.purchaseRate,
  isTypingMaking,
  isTypingWastage,
]);

  // const removeImage = async (indexToRemove) => {
  //   const imageToRemove = images[indexToRemove];

  //   // Optional: Ask confirmation before removing existing image
  //   if (!(imageToRemove instanceof File)) {
  //     const confirm = window.confirm("Are you sure you want to remove this existing image? It will be deleted on save.");
  //     if (!confirm) return;
  //   }

  //   console.log('index da',indexToRemove);

  //   const res = await deleteProductImage(indexToRemove)
  //   console.log('response',res);

  //   setImages(prev => prev.filter((_, index) => index !== indexToRemove));
  // };

  const removeImage = async (image) => {
    // If it's a File object (new upload), no API call needed
    if (image instanceof File) {
      setImages((prev) => prev.filter((img) => img !== image));
      toast("New image removed", "SUCCESS");
      return;
    }

    // Else: it's an existing image from DB
    const confirm = window.confirm("Delete this image permanently?");
    if (!confirm) return;

    try {
      await deleteProductImage(image.id); // Your API: DELETE /api/product-image?id=${id}
      setImages((prev) => prev.filter((img) => img.id !== image.id));
      toast("Image deleted successfully", "SUCCESS");
    } catch (err) {
      toast("Failed to delete image", "ERROR");
    }
  };
  const handleClearChange = () => {
    setProductForm({
      code: "",
      name: "",
      description: "",
      weight: "",
      makingCharge: "",
      wastageCharge: "",
      purity:"",
      status: "",
      stockAvailability: "",
      gst:"",
      discount:"",
      purchaseRate: "",
      purchaseGoldRate: "",
      purchaseDate: "",
      vendorId: "",
      categoryId: "",
      productType: "",
    });
    setImages([]);
    setIsCodeDuplicate(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      // Append all product fields
      Object.keys(productForm).forEach((key) => {
        formData.append(key, productForm[key]);
      });

      // If editing, include ID
      if (editIndex) {
        formData.append("id", editIndex.id);
      }

      // ✅ ONLY append NEW files (File instances)
      const newFiles = images.filter((img) => img instanceof File);
      newFiles.forEach((file) => {
        formData.append("imageUrl[]", file); // Must use "imageUrl[]" to match PHP
      });

      // Call API
      const response = await (editIndex
        ? updateProduct(editIndex.id, formData)
        : createProduct(formData));

       const duplicateCode = productData.some((item)=>item.code?.toLowerCase() === productForm.code?.toLowerCase()&&(!editIndex || item.id !== editIndex.id));

       if(duplicateCode){
        toast("Product code already exist","ERROR");
        return;
       }

      if (response.code === 200) {
        toast(
          `Product ${editIndex ? "updated" : "created"} successfully`,
          "SUCCESS",
        );
        fetchData();
        setShowModal(false);
        handleClearChange();
        setEditIndex(null);
      } else {
        throw new Error(response.message || "Save failed");
      }
    } catch (error) {
      console.error("Save error:", error);
      toast(error.message || "Failed to save product", "ERROR");
    }
  };

  const handleEdit = (wrapperObject) => {
    const product = wrapperObject.data;
    const productImages = wrapperObject.images || [];

    setEditIndex(product);
    setProductForm(product);

    // Set both existing {id, imageUrl} objects AND new files later
    setImages([...productImages]); // These are plain objects like { id, imageUrl }
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      await deleteProduct(id);
      toast("Product Deleted", "SUCCESS");
      fetchData();
    } else {
      toast("Deletion cancelled", "INFO");
    }
  };

  return (
    <Main>
      <PageContainer
        title="Product Page"
        buttonText={"ADD"}
        onButtonClick={() => {
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="xl"
          onClose={() => {
            setShowModal(false);
            setEditIndex(null);
            handleClearChange();
          }}
          headerText={editIndex ? "Update Product" : "Add Product"}
          centered
        >
          <ProductForm
            handleClearChange={handleClearChange}
            productForm={productForm}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            editIndex={editIndex}
            images={images}
            setImages={setImages}
            handleImageChange={handleImageChange}
            removeImage={removeImage}
            makingAmount={makingAmount}
            wastageAmount={wastageAmount}
            setMakingAmount={setMakingAmount}
            setWastageAmount={setWastageAmount}
            setIsTypingMaking={setIsTypingMaking}
            setIsTypingWastage={setIsTypingWastage}
            isCodeDuplicate={isCodeDuplicate}
            handleCodeBlur={handleCodeBlur}
          />
        </Modal>

        <CollapseCard title="Product List">
          <ProductsList
            productData={productData}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default ProductPage;
